export default function formatRg(rg) {
  return rg
    .replace(/[^\dXx]/g, '')
    .replace(/(\d{2})(\d{3})(\d{3})([\dXx])/, '$1.$2.$3-$4')
    .toUpperCase();
}
